import { send } from 'server';

export const initiateDocumentUpload = ({ successUrl, errorUrl, documentType, remotePaymentAccountId, service = 'netverify' }) => send({
    ID: 35688,
    description: 'Initiate document upload request',
    responses: [35689, 35690],
    service,
    successUrl,
    errorUrl,
    documentType,
    remotePaymentAccountId
});

export const getJWTToken = (serverUrl) => send({
    ID: 72057,
    description: 'Get JWT Token request',
    responses: [72058, 72059],
    serverUrl
});

export const checkIfUsernameIsAvailable = ({ userName, email, casinoName, token }) => send({
    ID: 31003,
    description: 'Checks if username is available',
    responses: [31004, 33007],
    userName,
    email,
    casinoName,
    ...token && { token }
});

export const checkInDotComListener = ({ getParameters, requestContent, casinoName }) => send({
    ID: 35875,
    description: 'CheckInDotCom Listener request',
    responses: [35876, 35877],
    getParameters,
    requestContent,
    casinoName
});

/* ~(TotalCasino Changes)~ */
export const setUserIBAN = ({ specificParams, isDefault = true, methodCode = 'BankTransferWDPL2' }) => send({
    ID: 33054,
    description: 'Create payment method account',
    specificParams,
    isDefault,
    methodCode,
    responses: [33055, 33056]
});

export const sendVerifyEmailRequest = ({ token, casinoName, correlationId }) => send({
    token,
    casinoName,
    correlationId,
    ID: 35556
});
